/** 产品多语言支持的语言列表 */

export interface SupportedLanguage {
  /** BCP47 语言码，如 zh/es/en */
  code: string;
  /** 显示标签 */
  label: string;
}

/** 默认语言码（对应主表 name/description，不进翻译表） */
export const DEFAULT_LANG = 'en';

/**
 * 支持的语言列表（默认语言 + 可录入翻译的语言）
 * 默认语言 en 固定首位（对应主表英文）；其余按总使用人口（母语 + 第二语言）降序。
 * label 使用各语言自称，便于国际化识别。
 */
export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  { code: 'en', label: 'English（默认）' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'ar', label: 'العربية' },
  { code: 'pt', label: 'Português' },
  { code: 'ru', label: 'Русский' },
  { code: 'ja', label: '日本語' },
  { code: 'de', label: 'Deutsch' },
  // 后续扩展只需在此追加
];
